"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const FormMarkdown_1 = __importDefault(require("./forms/FormMarkdown"));
const FormFileUpload_1 = __importDefault(require("./forms/FormFileUpload"));
const FormWithNestedFields_1 = __importDefault(require("./forms/FormWithNestedFields"));
const FormRegisterMaterial_1 = __importDefault(require("./forms/FormRegisterMaterial"));
const FormRegisterSimple_1 = __importDefault(require("./forms/FormRegisterSimple"));
const FormCompanyWidgets_1 = __importDefault(require("./forms/FormCompanyWidgets"));
const FormCompanySimple_1 = __importDefault(require("./forms/FormCompanySimple"));
const FormDynamicFieldsSelect_1 = __importDefault(require("./forms/FormDynamicFieldsSelect"));
exports.default = (0, mobx_react_1.observer)(({ menu, forms }) => {
    switch (true) {
        case menu.markdown:
            return (react_1.default.createElement(FormMarkdown_1.default, { form: forms.markdown }));
        case menu.fileUpload:
            return (react_1.default.createElement(FormFileUpload_1.default, { form: forms.fileUpload }));
        case menu.nestedFields:
            return (react_1.default.createElement(FormWithNestedFields_1.default, { form: forms.nestedFields }));
        case menu.registerMaterial:
            return (react_1.default.createElement(FormRegisterMaterial_1.default, { form: forms.registerMaterial }));
        case menu.registerSimple:
            return (react_1.default.createElement(FormRegisterSimple_1.default, { form: forms.registerSimple }));
        case menu.companyWidgets:
            return (react_1.default.createElement(FormCompanyWidgets_1.default, { form: forms.companyWidgets }));
        case menu.companySimple:
            return (react_1.default.createElement(FormCompanySimple_1.default, { form: forms.companySimple }));
        case menu.dynamicFieldsSelect:
            return (react_1.default.createElement(FormDynamicFieldsSelect_1.default, { form: forms.dynamicFieldsSelect }));
        default: return null;
    }
});
